import { render, staticRenderFns } from "./SensorProperty.vue?vue&type=template&id=996945b6&scoped=true&lang=pug&"
import script from "./SensorProperty.vue?vue&type=script&lang=ts&"
export * from "./SensorProperty.vue?vue&type=script&lang=ts&"
import style0 from "./SensorProperty.vue?vue&type=style&index=0&id=996945b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996945b6",
  null
  
)

export default component.exports